/**
 * 공지 팝업과 새 소식 팝업이 한 번 방문(페이지 로드)에 겹쳐 뜨지 않게 한다.
 * - 공지가 먼저 뜨면 이번 방문에는 새 소식을 자동으로 띄우지 않는다 (다음 방문으로 미룬다).
 * - 새 소식이 열려 있는 동안에는 공지를 띄우지 않는다.
 * 메모리에만 두므로 새로고침하면 처음부터 다시 판단한다.
 */
let noticeShown = false;
let whatsNewOpen = false;

export const markNoticePopupShown = () => { noticeShown = true; };
export const wasNoticePopupShown = () => noticeShown;
export const setWhatsNewOpen = (open) => { whatsNewOpen = Boolean(open); };
export const isWhatsNewOpen = () => whatsNewOpen;

export const resetPopupGateForTest = () => {
  noticeShown = false;
  whatsNewOpen = false;
};
